import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import PageLayout from '../../components/PageLayout.vue';
import SqlJson from '../../components/SqlJson.vue';
export default {
  __name: 'SqlJsonPage',
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(PageLayout, {
        title: "SQL转JSON / JSON转SQL",
        "current-page": "url"
      }, {
        default: _withCtx(() => [_createVNode(SqlJson)]),
        _: 1
      });
    };
  }
};